module.exports = __webpack_public_path__ + "assets/img/stihl_allinclusive_sticker_NOR.004ccf45.png";